'use strict';

var novicell = novicell || {};

novicell.acordion = novicell.acordion || new function () {

  this.init = function () {
    let accordions = document.querySelectorAll('.js-accordion-trigger');
    if (accordions.length) {
      for (let i = 0; i < accordions.length; i++) {
        accordions[i].addEventListener('click', function() {
          let items = this.parentNode.querySelector('.js-accordion-items');
          let iconNotExpanded = this.querySelector('.js-accordion-icon-not-expanded');
          let iconExpanded = this.querySelector('.js-accordion-icon-expanded');
          items.classList.toggle('accordion__items--active');
          if (items.classList.contains('accordion__items--active')) {
            iconNotExpanded.classList.remove('active');
            iconExpanded.classList.add('active');
          } else {
            iconNotExpanded.classList.add('active');
            iconExpanded.classList.remove('active');
          }
        });
      }
    }
    let filesDropdownLink = document.querySelectorAll('.js-accordion-item-file-trigger');
    if (filesDropdownLink.length) {
      for (let x = 0; x < filesDropdownLink.length; x++) {
        filesDropdownLink[x].addEventListener('click', function() {
          this.parentNode.querySelector('.js-accordion-item-languages-dropdown').classList.toggle('accordion-item-file__languages-dropdown--active');
        });
      }
    }
  };
}();
